<template>
  <div>

    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader class="p-1">
            <CRow>
              <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                <strong >{{$t('router.listSuppliers')}}</strong>

              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton
                    class="mr-1"
                    size="sm"
                    color="secondary"
                >{{ $t("buttons.print") }}
                </CButton>
                <a href="/dashboard/orders/add-supplier" target="_blank">
                  <CButton
                      class="mr-1"
                      size="sm"
                      color="dark"
                  >
                    <CIcon size="sm" name="cil-plus"></CIcon>
                  </CButton>
                </a>

              </CCol>
            </CRow>
            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="3">
                <CSelect :options="[{label:$i18n.t('all'),value:0},{label:$i18n.t('active'),value:1},{label:$i18n.t('deactivate'),value:2}]"
                         :value.sync="selected_status"
                />
              </CCol>
            </CRow>
                <CDataTableFixed
                    :height="get_pagination? '210px' : ''"
                    :items="items_vendor"
                    :fields="fields"
                    @row-clicked="table_row_clicked"
:pagination="get_pagination"
                    :items-per-page="20"
                    hover
                    sorter
                    column-filter

                >
                  <template #row_id="{item,index}">

                    <td style="text-align: center">
                      <p >{{ index + 1 }}</p>

                    </td>

                  </template>
                  <template #userName="{item}">

                    <td>
                      <p >{{ item.userName }}</p>

                    </td>

                  </template>
                  <template #userNameTwo="{item}">
                    <td>
                      <p v-if="item.userNameTwo">{{ item.userNameTwo }}</p>
                    </td>
                  </template>

                  <template #mobileNoTwo="{item}">
                    <td>
                      <p v-if="item.mobileNoTwo">{{ item.mobileNoTwo }}</p>
                    </td>
                  </template>

                  <template #title="{item}">
                    <td>
                      <p v-if="item.title!=null" >{{ item.title }}</p>
                    </td>
                  </template>
                  <template #surName="{item}">
                    <td>
                      <p v-if="item.surName!=null" >{{ item.surName }}</p>
                    </td>
                  </template>
                  <template #email="{item}">
                    <td>
                      <p v-if="item.email!=null" >{{ item.email }}</p>
                    </td>
                  </template>
                  <template #jobProfile="{item}">
                    <td>
                      <p v-if="item.jobProfile!=null" >{{ item.jobProfile }}</p>
                    </td>
                  </template>
                  <template #branch="{item}">
                    <td>
                      <p v-if="item.branch!=null" >{{ item.branch }}</p>
                    </td>
                  </template>
<template #categoryName="{item}">
                    <td>
                      <p v-if="item.categoryName!=null" >{{ item.categoryName }}</p>
                    </td>
                  </template>


                  <template #operation="{item}">
                    <td >
                      <CButton
                          class="mr-1"
                          color="primary"
                          variant="outline"
                          square
                          :title="$t('buttons.edit')"

                          size="sm"
                          @click="goEditPerson(item)"
                      >
                        <CIcon name="cil-pencil"/>
                      </CButton>
                      <CButton
                              v-if="get_access('sell_supplier_direct')"
                          class="mr-1"
                          color="primary"
                          variant="outline"
                          square
                          :title="$t('buttons.edit')"
                          size="sm"
                          @click="$router.push({path:'/dashboard/orders/supplier-docs/'+item.userId})"
                      >
                        <CIcon name="cil-list"/>
                      </CButton>
<!--                      <CButton class="mr-1"-->
<!--                               color="success"-->
<!--                               variant="outline"-->
<!--                               square-->
<!--                               size="sm"-->
<!--                               :title="$t('buttons.documents')"-->
<!--                               @click="goToDocuments(item)"-->
<!--                      >-->
<!--                        <CIcon name="cil-list-rich"/>-->
<!--                      </CButton>-->
                        <CButton
                            class="mr-1"
                            size="sm"
                            v-if="get_access('sell_supplier_direct')"

                            @click="window.open('/dashboard/orders/supplier-products/'+item.userId)"
                            color="success"
                        >
                          <CIcon size="sm" name="cil-applications"></CIcon>
                        </CButton>

                    </td>
                  </template>


                </CDataTableFixed>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items_data = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      selected_template: 0,
      description: '',
      saleMethodModal: false,
      method_list: [],
      selected_method: '',
      selected_person: 0,
      selected_status:0,

      fields: [
        {key: 'row_id', label: this.$t('tables.row'),sorter:false, _style: 'width:5%'},
        // {key: 'personCode', label: this.$t('personalNo'), _style: 'width:10%'},
        {key: 'personCode', label: this.$t('tables.code'), _style: 'width:5%'},
        {key: 'userName', label: this.$t('components.name'), _style: 'width:10%'},
        {key: 'surName', label: this.$t('lastName'), _style: 'width:10%'},
        {key: 'mobileNo', label: this.$t('mobile'), _style: 'width:10%'},
        {key: 'userNameTwo', label: this.$t('SalesPerson'), _style: 'width:10%'},
        {key: 'mobileNoTwo', label: this.$t('mobile'), _style: 'width:10%'},

        {key: 'paymentMethodTitle', label: this.$t('PaymentStatus'), _style: 'width:10%'},
        // {key: 'categoryName', label: this.$t('tables.category'), _style: 'width:10%'},
        {key: 'operation', label: this.$t('tables.operation'),sorter:false, _style: 'width:10%'},
        // {key: 'jobProfile', label: this.$t('jobTitle'), _style: 'width:10%'},
        // {key: 'branch', label: this.$t('branch'), _style: 'width:10%'},
      ],

      items_vendor: items_data.map((item, row_id) => {
        if (item.isVendor) {

          return {...item, row_id}
        }
      }),
      // fields,

      details: [],
      templates_items: [
        {template_id: 'One', name: 'A'},
        {template_id: 'Two', name: 'B'},
        {template_id: 'Three', name: 'C'}
      ],
      collapseDuration: 0,
      status_form: 0,
      table_clicks: 0,
      table_clicks_timer: null,
    }
  }, mounted() {

    this.$root.root_validate_errors = [];
    this.get_method_lists();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    },
    'selected_status': function () {
      this.get_lists();
    }
  },
  methods: {
    table_row_clicked(item, index) {

      this.table_clicks++;
      if (this.table_clicks == 1) {
        this.table_clicks_timer = setTimeout(() => {
          // this.result.push(event.type);
          this.table_clicks = 0
        }, 500);
      } else if (this.table_clicks > 1) {
        clearTimeout(this.table_clicks_timer);
        this.goEditPerson(item)

      }

    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = this.items[item.row_id].unitName;
      this.color = this.items[item.row_id].color;
      this.description = this.items[item.row_id].description;
      this.previewImage = this.items[item.row_id].image;
      this.status_form = this.items[item.row_id].id;
    },
    get_method_lists() {
      var self = this;

      const formData = new FormData();


      axios.post('GetPriceMethodTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        if (content_data.statusCode == 0) {
          content_data.data.forEach((val) => {
            var obj = {label: val.title, value: val.id}

            self.method_list.push(obj);
          });
          if (self.$route.params.area_id == null) {
            self.get_lists();

          } else {
            self.get_listsByArea();

          }
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    edit_person_sale_method(method,user_id){
this.saleMethodModal = false;
      let self = this;
      const formData = new FormData();
      let url;
      url = "EditPersonMethod";
      formData.append('MethodId', method);
      formData.append('PersonId',user_id);
      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {

        self.selected_method = '';
        self.selected_person = 0;

        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, edit_sale_method(item) {
      this.selected_method = item.saleMethodId;
      this.selected_person = item.userId;
      this.saleMethodModal = true;

    },
    get_lists() {
      var self = this;


      const formData = new FormData();
      var url = "GetAllPersons";

      formData.append('IsVendor', true);
      formData.append('IsWorker', false);
      formData.append('IsCustomer', false);
      formData.append('IsActive', this.selected_status);


      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {

          self.items_vendor = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_listsByArea() {
      var self = this;


      const formData = new FormData();

      var url = "GetUsers";

      formData.append("area_id", this.$route.params.area_id);

      axios.post(url, formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items_customer = content_data.data.map((item, row_id) => {
// if(item.isCustomer){
            return {...item, row_id}

// }
          });

          self.items_customer = self.items_customer.filter(item => item.isCustomer);

          self.items_vendor = content_data.data.map((item, row_id) => {
            // console.log(item.isVendor);
            // if(item.isVendor){
            return {...item, row_id}

            // }
          });
          self.items_vendor = self.items_vendor.filter(item => item.isVendor);

          self.items_worker = content_data.data.map((item, row_id) => {
            // if(item.isCustomer){
            return {...item, row_id}

            // }
          });
          self.items_worker = self.items_worker.filter(item => item.isWorker);


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goEditPerson(item) {

      // this.$router.push({path: '/dashboard/orders/edit-supplier/' + item.userId});
      window.open('/dashboard/orders/edit-supplier/' + item.userId)
    },
    goToDocuments(item) {

      this.$router.push({path: '/dashboard/documents/person-list/' + item.userId});

    },
    goToAccountingReport(item) {

      this.$router.push({path: '/dashboard/users/user-accounting-report/' + item.userId});

    },
    goToPorsant(item) {
      this.$router.push({path: '/dashboard/users/user-porsant/' + item.userId});
    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeletePerson";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
